import { render, staticRenderFns } from "./productDataTable.vue?vue&type=template&id=47ff94fa&scoped=true"
import script from "./productDataTable.vue?vue&type=script&lang=js"
export * from "./productDataTable.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/styles/introduce-common.scss?vue&type=style&index=0&id=47ff94fa&prod&lang=scss&scoped=true&external"
import style1 from "./productDataTable.vue?vue&type=style&index=1&id=47ff94fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff94fa",
  null
  
)

export default component.exports